import { Box, Container, Typography } from '@mui/material';
import iconGrop from '../../assets/img/mobileLanding/cta-icons.png';
import { BackgroundElement } from './elements';
import CTAButtons from './elements/CTAButtons';
import useDevice from 'hooks/useDevice';

function CallBackSection({ type }: { type: 'web' | 'mobile' }) {
    const { screenWidth } = useDevice();
    const isWeb = type === 'web';

    return (
        <Box
            component="section"
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#000',
                minHeight: isWeb ? 'auto' : '40vh',
                pb: isWeb ? 0 : 10,
                zIndex: isWeb ? 10 : 'auto',
            }}
        >
            <Container
                maxWidth="lg"
                sx={{
                    px: isWeb ? 0 : 2,
                    py: isWeb ? 2 : 5,
                    height: 'auto',
                    width: '100%'
                }}
                className={isWeb ? 'px-zero' : ''}
            >
                <Box
                    sx={{
                        textAlign: 'left',
                        px: isWeb ? 0 : 1,
                        color: "#BBC3DA"
                    }}
                >
                    <Typography
                        variant="body1"
                        className='font-satoshi-regular'
                        sx={{
                            color: '#BBC3DA',
                            fontSize: isWeb ? '18px' : (screenWidth < 330 ? '18px' : '24px'),
                            lineHeight: 1.6,
                            position: 'relative',
                            textAlign: "left",
                            ...((screenWidth < 786) && {
                                maxWidth: '430px',
                                margin: "auto"
                            })
                        }}
                    >
                        <BackgroundElement
                            sx={{
                                top: '-7rem',
                                right: '1rem',
                            }}
                        />
                        {isWeb ? <>
                            Osperb Innovations is a custom software development<br /> company that combines{' '}
                            <Box component="span" sx={{ fontWeight: 700, color: "white" }}>
                                systems thinking
                            </Box>{' '}
                            and{' '} <br />
                            <Box component="span" sx={{ fontWeight: 700, color: "white" }}>
                                customer psychology
                            </Box>{' '}
                            to build enterprise software <br /> and mobile apps with modern stacks like <br />
                        </> :
                            <>
                                Osperb Innovations is a custom software development company that combines{' '}<br />
                                <Box component="span" sx={{ fontWeight: 700, color: "white" }}>
                                    systems thinking
                                </Box>{' '}
                                and{' '} <br />
                                <Box component="span" sx={{ fontWeight: 700, color: "white" }}>
                                    customer psychology
                                </Box>{' '}
                                to build enterprise software and mobile apps with modern stacks like <br />
                            </>}

                        <Box component="span" sx={{ fontWeight: 700, color: "white" }}>
                            Node.js, Python, React.js and Flutter.
                        </Box>

                        <BackgroundElement
                            sx={{
                                top: '3rem',
                                right: '9rem',
                            }}
                        />
                    </Typography>


                    {/* Icon Group */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: isWeb ? 'flex-start' : 'center',
                            alignItems: 'center',
                            mb: isWeb ? 2 : 0.5,
                            maxWidth: "130px",
                            mx: isWeb ? "0" : "auto"
                        }}
                    >
                        <Box
                            component="img"
                            src={iconGrop}
                            alt="Technology Icons"
                            sx={{
                                height: '60px',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>

                    {/* CTA Buttons */}
                    <CTAButtons textColor="#FFFFFF99" b2style="outlined" direction={isWeb ? 'row' : 'column'}
                        whatsAppHelperText={isWeb ? <>
                            Have a quick question? Our <br /> team will reply on WhatsApp.
                        </> : 'Have a quick question? Our team will reply on WhatsApp.'}

                    />
                </Box>
            </Container>
        </Box>
    );
}

export default CallBackSection;
